import { render, staticRenderFns } from "./eventPromotion.vue?vue&type=template&id=cdf5c5b6"
import script from "./eventPromotion.vue?vue&type=script&lang=js"
export * from "./eventPromotion.vue?vue&type=script&lang=js"
import style0 from "./eventPromotion.vue?vue&type=style&index=0&id=cdf5c5b6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports